import { render, staticRenderFns } from "./BookableCategory.vue?vue&type=template&id=4c0a1d52&scoped=true"
import script from "./BookableCategory.vue?vue&type=script&lang=js"
export * from "./BookableCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a1d52",
  null
  
)

export default component.exports